/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.35.0-dev.20221105(05ec31617136e13a0902f34eb6634546d1c66ef8)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.zh-cn", {
	"vs/base/common/platform": [
		"_",
	]
});